/** Высота fixed PreviewMenu — совпадает с `html:has` в PreviewMenu.vue. */
export const PREVIEW_MENU_OFFSET_MOBILE = '56px'
export const PREVIEW_MENU_OFFSET_DESKTOP = '72px'
